import React, { useEffect } from "react";

import getContentById from "../../../../shared/utils/getContentById";
import _ from "lodash";
import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, {
  animationCleanUp,
} from "../../../../../animations/worldcup/playercompare";

import assets from "./assets";
import getOptaCountryCode from "../../../../shared/utils/getOptaCountryCode";
import { getPlayerStats, getPlayerStatsForSD } from "../../../../shared/utils/opta/statsHandler";
// import outroVideo9x16 from "../../../assets/outros/outro_playoffs_9x16.webm";

require("./style/style.scss");
require("./style/animation.scss");

import {
  positionTranslations,
  positionExtension,
} from "../../../../shared/utils/opta/player";
import { useTranslation } from "react-i18next";
import { getPlayerPosition } from "../../../../shared/utils/players";
import Image from "../../../../shared/components/Image";
import { getShortPlayerName } from "../../../../shared/feeds/worldcup/playerHelper";
import { WcBgCircle } from "../../../../shared/backgrounds/WcBgCircle/Index";
import ProgressBar from "../../../../shared/components/ProgressBar";
import { MatchScoreWidget } from "../../_partials/MatchScoreWidget/MatchScoreWidgetSD";
import { PlayerTriko } from "../../_partials/PlayerTrikoSD/Index";

const Index = (props) => {
  const refs = {
    player: React.createRef(),
    team: React.createRef(),
  };

  const {
    animation,
    data,
    images: Images,
    apiSetup,
    mode,
    format,
    isTimeline,
  } = props;

  const { t } = useTranslation();

  const id = `${_.get(data, "template_name", "")}_${_.get(data, "uuid", "")}`;

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };

  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          refs,
          data,
          animation,
          mode,
          id,
          format,
          apiSetup,
          templateName: data?.template_name
        });
      }
    }

    //handle outro video BEGIN
    // if(mode === "video" && !isTimeline) {
    //   const outroVideo = $(`#${id} video.outro-optional-video`);
    //   outroVideo.get(0).addEventListener("loadedmetadata", function() {
    //       const that = this;
    //       setTimeout(()=> {
    //         outroVideo?.css('opacity', 1);
    //         this.currentTime = 0;
    //         that.play();
    //       }, frontendCfg.showOutroAfter)
    //     }, false);
    // }
    //handle outro video END

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  const templateData = _.get(data, "data");

  const { options, fields, dynamic } = templateData;
  const matchInfo = _.get(dynamic, "matchInfo");

  const playerCompare = _.get(dynamic, "playerCompare");

  const competitionId = matchInfo?.competition?.id

  const backgroundImage = getMainBackground(format, _.get(dynamic, "teamSide"));

  const homeTeam = matchInfo?.TeamStatistic?.[0];
  const awayTeam = matchInfo?.TeamStatistic?.[1];

  const playerHome = _.get(playerCompare, "home");
  const playerAway = _.get(playerCompare, "away");
  const homeStats = playerHome;
  const awayStats = playerAway;
  const kits = _.get(dynamic, "kits");

  const statsMappingHome = getPlayerStatsForSD(
    _.toLower(playerHome?.position),
    homeStats,
  );
  const statsMappingAway = getPlayerStatsForSD(
    _.toLower(playerHome?.position),
    awayStats,
  );

  return (
    <div
      id={id}
      className={`T_${_.get(data, "template_name", "")} ${animation ? "animation" : ""} side-${_.get(dynamic, "teamSide")}`}
    >
      <TemplateBlock>
        <Backgrounds bg1={backgroundImage} loop={true} />

        <div className={"wc-content wc-content-v2"}>
          <ProgressBar height={"8px"} strokeColor="#177C76" />
          <div className={"wc-bg-content"}></div>

          <div className={"dfb-tv-logo"}>
            <img src={assets.sd_dfb_tv_logo} />
          </div>

          <MatchScoreWidget
            homeTeam={homeTeam}
            awayTeam={awayTeam}
            matchInfo={matchInfo}
          />

          <div className={"versus-info"}>
          </div>

          <div className={"teams-block"}>
            <PlayerTriko
              className={"left-player"}
              player={playerHome}
              teamId={homeTeam?.TeamId}
              side={"home"}
              bgColor={kits?.home?.colour1}
              team={homeTeam}
              competitionId={competitionId}
            />

            <PlayerTriko
              className={"right-player"}
              player={playerAway}
              teamId={awayTeam?.TeamId}
              side={"away"}
              bgColor={kits?.away?.colour1}
              team={awayTeam}
              competitionId={competitionId}
            />
          </div>

          <div className={"main-header green-glow"}>
            {t("Head 2 Head", { keyPrefix: "templates" })}
          </div>

          <div className={"team-stats"}>
            {statsMappingHome.map((statRowHome, index) => {
              const statRowAway = statsMappingAway?.[index];
              return (
                <div key={statRowHome.type} className={"stat-row"}>
                  <div className={"stat-home"}>{statRowHome?.value || "0"}</div>
                  <div className={"stat-label"}>
                    {t(statRowHome?.type, { keyPrefix: "stats" })}
                  </div>
                  <div className={"stat-away"}>{statRowAway?.value || "0"}</div>
                </div>
              );
            })}
          </div>
        </div>
      </TemplateBlock>
    </div>
  );
};

const getMainBackground = (format, side) => {
  return _.get(assets, `sd_background_1920`);
};

export default Index;
